import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDown } from "lucide-react";

interface ActionButtonItem {
  text: string;
  onClick: () => void;
  icon: React.ReactNode;
  disabled?: boolean;
}

interface PostActionButtonProps {
  text: string;
  onClick: () => void;
  icon: React.ReactNode;
  disabled?: boolean;
  actionButtons: ActionButtonItem[];
  anchor?: string;
  buttonClassName?: string;
}

const PostActionButton = ({
  text,
  onClick,
  icon,
  disabled,
  actionButtons,
  anchor = "top end",
  buttonClassName = "",
}: PostActionButtonProps) => {
  return (
    <Menu as="div" className="relative inline-flex z-20">
      <button
        className={`flex items-center gap-2 pl-3 rounded-lg bg-blue-600 text-white hover:bg-blue-700 border border-gray-200 disabled:bg-gray-50 disabled:text-gray-400 cursor-pointer ${buttonClassName}`}
        onClick={onClick}
        disabled={disabled}
      >
        {icon}
        {text}
        {actionButtons.length > 0 ? (
          <div className="flex items-center">
            <span className="h-5 border-1 border-white/40"></span>
            <MenuButton
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
              as="span"
              className="inline-flex items-center pl-2 pr-3 py-2.5"
              disabled={disabled}
            >
              <ChevronDown className="w-4 h-4" />
            </MenuButton>
          </div>
        ) : (
          <div className="py-4.5"></div>
        )}
      </button>
      {actionButtons.length > 0 ? (
        <MenuItems
          transition
          anchor={anchor as any}
          className="z-50 rounded-lg border border-gray-200 bg-white p-1 transition duration-100 ease-out [--anchor-gap:0px] focus:outline-none data-closed:scale-95 data-closed:opacity-0"
        >
          {actionButtons.map((item) => (
            <MenuItem key={item.text}>
              <button
                onClick={item.onClick}
                className="group flex w-full items-center gap-2 rounded-lg px-3 py-1.5 whitespace-nowrap data-focus:bg-gray-200"
                disabled={item.disabled}
              >
                {item.icon}
                {item.text}
              </button>
            </MenuItem>
          ))}
        </MenuItems>
      ) : null}
    </Menu>
  );
};

export default PostActionButton;
